
export default class BehaviorService {
  constructor(RecordService, TemplateService) {
    'ngInject';
    this.rs = RecordService;
    this.ts = TemplateService;
  }

  // childElementId: token Id, or block Id
  evalVisibleBehavior(childElementId) {
    const behavior = this.behaviorByProperty(childElementId, "visible");
    if (behavior) {
      const visible = this.evalConditions(behavior);
      return behavior.behavior == "Show" ? visible : !visible;
    }
    return true;
  }

  evalRequiredBehavior(tokenId) {
    const behavior = this.behaviorByProperty(tokenId, "required");
    if (behavior) {
      const required = this.evalConditions(behavior);
      return behavior.behavior == "Require" ? required : !required;
    }
    return false;
  }

  evalEnabledBehavior(tokenId) {
    const behavior = this.behaviorByProperty(tokenId, "enabled");
    if (behavior) {
      const disabled = this.evalConditions(behavior);
      return behavior.behavior == "Disabled" ? !disabled : disabled;
    }
    return true;
  }

  behaviorByProperty(childElementId, property) {
    const propMap = {
      "visible": ["Show", "Hide"],
      "enabled": ["Enabled", "Disabled"],
      "required": ["Require", "Un-Require"]
    };

    return this.ts.behaviors.find(b => {
      const { childId, behavior } = b;
      return childId === childElementId && propMap[property].indexOf(behavior) >= 0;
    });
  }

  evalConditions(behavior) {
    const { id: behaviorId, logic } = behavior;
    if (logic === 'always') return true;
    return this.ts.conditions.filter(c => c.behaviorId == behaviorId).reduce((acc, con) => {
      const { referenceId, operation, evaluation, fieldId, parentId } = con;
      const recValue = this.rs.records[referenceId][fieldId]?.value;
      const parentToken = this.ts.tokens.find(t => t.id == parentId);
      let left = parentToken?._formatter?.getBehaviorValue(recValue) || recValue;
      const right = this.getReverseCompatibleValue(evaluation);
      // Multi-checkbox: record value is a delimited set — reduce to whether this choice is selected
      if (parentToken._isBoolean && parentToken.options?.choice) {
        left = String(recValue || '').split(parentToken.control.delimiter).includes(parentToken.options.choice.value);
      }
      const result = this.evalOperation(parentToken, left, right, operation);
      return logic === "&&" ? acc && result : acc || result;
    }, logic === "&&");
  }

  // left: record value, right: condition value
  evalOperation(parentToken, left, right, operator) {
    const isBoolean = parentToken._isBoolean;
    switch (operator) {
      case "==":
        if (isBoolean) return this.toBoolean(left) === this.toBoolean(right);
        if (this.isEmpty(left)) return this.isEmpty(right);
        if (this.isEmpty(right)) return this.isEmpty(left);
        return left == right;
      case "!=":
        if (isBoolean) return this.toBoolean(left) !== this.toBoolean(right);
        if (this.isEmpty(left)) return !this.isEmpty(right);
        if (this.isEmpty(right)) return !this.isEmpty(left);
        return left != right;
      case "!!":
        return isBoolean? this.toBoolean(left): !this.isEmpty(left);
      case "!":
        return isBoolean? !this.toBoolean(left): this.isEmpty(left);
      default:
        return false;
    }
  }

  isEmpty = (val) => (val === null || val === undefined || val === "");
  toBoolean = (val) => (val !== 0 && val !== "0" && val !== false && val !== null && val !== undefined && val !== "")
  getReverseCompatibleValue = (model) => typeof model === 'object' ? model?.value : model;
}